import { C } from "../constants/colors";
import { JOURNEY_MODULES } from "../constants/modules";
import { detectCompletedPrompts, getVisiblePrompts } from "../utils/messages";

export function JourneyBar({ moduleMessages }) {
  const doneCount = JOURNEY_MODULES.filter(id => {
    const msgs = moduleMessages[id] || [];
    const visiblePrompts = getVisiblePrompts(id, msgs);
    if (visiblePrompts.length === 0) return false;
    const completed = detectCompletedPrompts(id, msgs);
    return completed.size === visiblePrompts.length;
  }).length;

  if (doneCount === 0) return null;
  const pct = (doneCount / JOURNEY_MODULES.length) * 100;

  return (
    <div style={{ height: 3, background: "#ffffff0a" }}>
      <div style={{
        height: "100%", width: `${pct}%`,
        background: `linear-gradient(90deg, ${C.teal}, ${C.tealLight})`,
        transition: "width 0.5s ease",
        borderRadius: "0 2px 2px 0",
      }} />
    </div>
  );
}
